import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const CREATE_LOCATION_URL = `${API_URL}/delivery/create-delivery-location`;

const GET_UNAVAILABLE_URL = `${API_URL}/delivery/list-unavailable-deliveries`;

const createDeliveryLocation = (data: any) => {
  return axios.post(CREATE_LOCATION_URL, data).then((response:any) => {
    console.log("Response:==================API", response);
    return response;
  });
};

const getUnavailableDeliveryLocations = () => {
  return axios.get(GET_UNAVAILABLE_URL).then((response) => {
     return response.data;
  });
};

export { createDeliveryLocation, getUnavailableDeliveryLocations };
